module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "er-page"
  }, [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Update Race")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Edit race details, stream settings, media and trainer ownership")])]), _vm._v(" "), _c('router-link', {
    staticClass: "er-ghost-btn",
    attrs: {
      "to": "/admin/races"
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 12H5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 19l-7-7 7-7"
    }
  })]), _vm._v("\n        Races\n      ")])], 1), _vm._v(" "), (!_vm.update) ? _c('div', {
    staticClass: "er-loading-stack"
  }, _vm._l((4), function(n) {
    return _c('section', {
      key: 'er-sk-' + n,
      staticClass: "er-card"
    }, [_c('div', {
      staticClass: "er-card-header"
    }, [_c('span', {
      staticClass: "er-icon er-icon--loading sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "er-skeleton-head"
    }, [_c('div', {
      staticClass: "er-sk-title sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "er-sk-sub sk-shimmer"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "er-grid er-grid--two"
    }, [_c('div', {
      staticClass: "er-sk-input sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "er-sk-input sk-shimmer"
    })])])
  }), 0) : _c('custom-form', {
    staticClass: "er-form",
    attrs: {
      "handle-submit": _vm.handleSubmit
    }
  }, [_c('section', {
    staticClass: "er-card"
  }, [_c('div', {
    staticClass: "er-card-header"
  }, [_c('span', {
    staticClass: "er-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "er-card-title"
  }, [_vm._v("Race Details")]), _vm._v(" "), _c('p', {
    staticClass: "er-card-sub"
  }, [_vm._v("Edit the core schedule, description and participant capacity")])])]), _vm._v(" "), _c('div', {
    staticClass: "er-grid er-grid--two"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "er-field",
    attrs: {
      "label": "Name",
      "name": "name",
      "data-vv-value-path": "input",
      "data-vv-name": "name",
      "error-message": "Fill in the name",
      "has-error": _vm.errors.has('name'),
      "required": true
    },
    model: {
      value: (_vm.update.name),
      callback: function($$v) {
        _vm.$set(_vm.update, "name", $$v)
      },
      expression: "update.name"
    }
  }), _vm._v(" "), _c('date-time-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "er-field",
    attrs: {
      "label": ("Date - " + (_vm.getTimezone())),
      "name": "date",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "date",
      "error-message": "Fill in the date",
      "has-error": _vm.errors.has('date'),
      "required": true
    },
    model: {
      value: (_vm.update.date),
      callback: function($$v) {
        _vm.$set(_vm.update, "date", $$v)
      },
      expression: "update.date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field er-field--full"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.update.description),
      expression: "update.description"
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('description')
    },
    attrs: {
      "data-vv-rules": "required",
      "name": "description",
      "rows": "6",
      "id": "txtArea",
      "required": ""
    },
    domProps: {
      "value": (_vm.update.description)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onDescriptionChange.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the description")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Duration in minutes "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.update.duration),
      expression: "update.duration",
      modifiers: {
        "number": true
      }
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('duration')
    },
    attrs: {
      "type": "number",
      "step": "1",
      "min": 1,
      "max": _vm.max_duration,
      "name": "duration",
      "required": ""
    },
    domProps: {
      "value": (_vm.update.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "duration", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duration')),
      expression: "errors.has('duration')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the duration")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "rsvp_limit"
    }
  }, [_vm._v("RSVP Limit "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.update.rsvp_limit),
      expression: "update.rsvp_limit",
      modifiers: {
        "number": true
      }
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('rsvp_limit')
    },
    attrs: {
      "type": "number",
      "step": "1",
      "min": 1,
      "max": _vm.max_rsvp_limit,
      "name": "rsvp_limit",
      "required": ""
    },
    domProps: {
      "value": (_vm.update.rsvp_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "rsvp_limit", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rsvp_limit')),
      expression: "errors.has('rsvp_limit')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the RSVP limit")])])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "er-card"
  }, [_c('div', {
    staticClass: "er-card-header"
  }, [_c('span', {
    staticClass: "er-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4h16v16H4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 9h16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 20V9"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "er-card-title"
  }, [_vm._v("Type And Stream")]), _vm._v(" "), _c('p', {
    staticClass: "er-card-sub"
  }, [_vm._v("Update medal behavior, categories, language and audio routing")])])]), _vm._v(" "), _c('div', {
    staticClass: "er-grid er-grid--two"
  }, [_c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("First Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.type),
      expression: "update.type"
    }],
    staticClass: "er-select",
    attrs: {
      "label": "First Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "LIVE"
    }
  }, [_vm._v("Live (Medal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v("No Medal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_MEDAL"
    }
  }, [_vm._v("On demand (Medal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_NO_MEDAL"
    }
  }, [_vm._v("On demand (No Medal)")])])]), _vm._v(" "), (_vm.update.type == 'ON_DEMAND_MEDAL' || _vm.update.type == 'ON_DEMAND_NO_MEDAL') ? _c('race-media', {
    staticClass: "er-field",
    attrs: {
      "label": "On demand File",
      "name": "media",
      "data-vv-value-path": "input",
      "data-vv-name": "media",
      "error-message": "Fill in the audio",
      "has-error": _vm.errors.has('media'),
      "required": false
    },
    on: {
      "saved": _vm.loadAudio
    },
    model: {
      value: (_vm.update.audioFileUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "audioFileUrl", $$v)
      },
      expression: "update.audioFileUrl"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.update.type == 'ON_DEMAND_MEDAL' || _vm.update.type == 'ON_DEMAND_NO_MEDAL') && _vm.update.audioFileUrl) ? _c('div', {
    staticClass: "er-audio-box er-field er-field--full"
  }, [_c('span', {
    staticClass: "er-preview-label"
  }, [_vm._v("Current on demand file")]), _vm._v(" "), _c('audio', {
    staticClass: "er-audio",
    attrs: {
      "id": "ondemand-audio",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.update.audioFileUrl,
      "type": "audio/mp3"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "secondType"
    }
  }, [_vm._v("Second Type")]), _vm._v(" "), (_vm.raceTypesLoading) ? _c('div', {
    staticClass: "er-sk-input sk-shimmer"
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.secondType),
      expression: "update.secondType"
    }],
    staticClass: "er-select",
    attrs: {
      "label": "Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "secondType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.raceTypes), function(type) {
    return _c('option', {
      key: type.name,
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.englishText))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "thirdType"
    }
  }, [_vm._v("Third Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.thirdType),
      expression: "update.thirdType"
    }],
    staticClass: "er-select",
    attrs: {
      "label": "Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "thirdType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("NONE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v("NO MEDAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoL"
    }
  }, [_vm._v("L")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoI"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoV"
    }
  }, [_vm._v("V")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoE"
    }
  }, [_vm._v("E")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LIVE_60MIN"
    }
  }, [_vm._v("60MIN_MEDAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoU"
    }
  }, [_vm._v("U")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoR"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MEDAL_20K"
    }
  }, [_vm._v("20Km Medal")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "channel"
    }
  }, [_vm._v("Channel")]), _vm._v(" "), (_vm.channelsLoading) ? _c('div', {
    staticClass: "er-sk-input sk-shimmer"
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.mobileChannelToPlay),
      expression: "update.mobileChannelToPlay"
    }],
    staticClass: "er-select",
    attrs: {
      "label": "Channel",
      "name": "channel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "mobileChannelToPlay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.channels.audioChannelA
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelB
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelC
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelD
    }
  }, [_vm._v("D")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "language"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.language),
      expression: "update.language"
    }],
    staticClass: "er-select",
    attrs: {
      "label": "Language",
      "name": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.update, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      key: locale.id,
      domProps: {
        "value": locale.id
      }
    }, [_vm._v(_vm._s(locale.name))])
  }), 0)])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "er-card"
  }, [_c('div', {
    staticClass: "er-card-header"
  }, [_c('span', {
    staticClass: "er-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07L11.5 4.43"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07l1.33-1.33"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "er-card-title"
  }, [_vm._v("Action Link")]), _vm._v(" "), _c('p', {
    staticClass: "er-card-sub"
  }, [_vm._v("Update the end-session URL and optional circular action image")])])]), _vm._v(" "), _c('div', {
    staticClass: "er-grid er-grid--two"
  }, [_c('div', {
    staticClass: "er-field"
  }, [_c('label', {
    staticClass: "er-label",
    attrs: {
      "for": "endSessionUrl"
    }
  }, [_vm._v("Action URL")]), _vm._v(" "), _c('text-field', {
    attrs: {
      "name": "endSessionUrl",
      "data-vv-value-path": "input",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.update.endSessionUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "endSessionUrl", $$v)
      },
      expression: "update.endSessionUrl"
    }
  })], 1), _vm._v(" "), _c('race-photo', {
    staticClass: "er-field",
    attrs: {
      "label": "Action Image",
      "name": "actionImage",
      "data-vv-value-path": "input",
      "data-vv-name": "actionImage",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('actionImage'),
      "required": false
    },
    model: {
      value: (_vm.update.actionImageUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "actionImageUrl", $$v)
      },
      expression: "update.actionImageUrl"
    }
  }), _vm._v(" "), (_vm.update.actionImageUrl != '') ? _c('div', {
    staticClass: "er-action-preview er-field er-field--full"
  }, [_c('div', [_c('span', {
    staticClass: "er-preview-label"
  }, [_vm._v("Current action image")]), _vm._v(" "), _c('img', {
    staticClass: "er-action-img",
    attrs: {
      "src": _vm.update.actionImageUrl,
      "alt": "Current action image"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "er-icon-btn er-icon-btn--delete",
    attrs: {
      "type": "button",
      "title": "Remove action image"
    },
    on: {
      "click": _vm.removeActionImg
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 11v6M14 11v6"
    }
  })])])]) : _vm._e()], 1)]), _vm._v(" "), _c('section', {
    staticClass: "er-card"
  }, [_c('div', {
    staticClass: "er-card-header"
  }, [_c('span', {
    staticClass: "er-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 7h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "er-card-title"
  }, [_vm._v("Tags And Trainer")]), _vm._v(" "), _c('p', {
    staticClass: "er-card-sub"
  }, [_vm._v("Update race tags and the trainer assigned to this session")])])]), _vm._v(" "), _c('div', {
    staticClass: "er-grid er-grid--two"
  }, [_c('div', {
    staticClass: "form__group er-field race-tags"
  }, [_c('label', {
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), (_vm.tagsLoading) ? _c('div', {
    staticClass: "er-sk-input sk-shimmer"
  }) : _c('selectize', {
    staticClass: "er-selectize-hidden",
    attrs: {
      "options": _vm.tagsOptions,
      "multiple": "",
      "size": "1",
      "isRunnerTag": false,
      "isRaceTag": true,
      "raceId": this.$route.params.raceId,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group er-field"
  }, [_c('label', {
    attrs: {
      "for": "Trainer"
    }
  }, [_vm._v("Trainer")]), _vm._v(" "), (_vm.trainerLoading) ? _c('div', {
    staticClass: "er-sk-input sk-shimmer"
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trainerId),
      expression: "trainerId"
    }],
    staticClass: "er-select trainer-list",
    attrs: {
      "label": "Trainer",
      "name": "Trainer"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trainerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeTrainer]
    }
  }, _vm._l((_vm.trainerList), function(trainer, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trainer.id
      }
    }, [_vm._v(_vm._s(trainer.firstName))])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "er-card"
  }, [_c('div', {
    staticClass: "er-card-header"
  }, [_c('span', {
    staticClass: "er-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "21 15 16 10 5 21"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "er-card-title"
  }, [_vm._v("Race Photo")]), _vm._v(" "), _c('p', {
    staticClass: "er-card-sub"
  }, [_vm._v("Update the image shown with this race in the mobile app")])])]), _vm._v(" "), _c('div', {
    staticClass: "er-photo-grid"
  }, [(_vm.update.imageUrl != '') ? _c('div', {
    staticClass: "er-photo-preview"
  }, [_c('span', {
    staticClass: "er-preview-label"
  }, [_vm._v("Current race photo")]), _vm._v(" "), _c('img', {
    staticClass: "er-photo-img",
    attrs: {
      "src": _vm.update.imageUrl,
      "alt": "Current race photo"
    }
  })]) : _vm._e(), _vm._v(" "), _c('upload-photo', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "er-field",
    attrs: {
      "label": "Photo",
      "name": "photo",
      "data-vv-value-path": "input",
      "data-vv-name": "photo",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('photo'),
      "required": true
    },
    model: {
      value: (_vm.update.imageUrl),
      callback: function($$v) {
        _vm.$set(_vm.update, "imageUrl", $$v)
      },
      expression: "update.imageUrl"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "er-actions"
  }, [_c('router-link', {
    staticClass: "er-ghost-btn",
    attrs: {
      "to": "/admin/races"
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "er-primary-btn",
    attrs: {
      "type": "submit",
      "id": "submit-form",
      "disabled": _vm.isSubmitting
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.isSubmitting ? 'Updating...' : 'Update Race') + "\n        ")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777efaea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/Update.vue
// module id = 1730
// module chunks = 2